import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';

type BreadSrumbType = {
  to?: string;
  label: string;
}
type BreadcrumbsCustomProps = {
  breadcrumbs: BreadSrumbType[];
};

const BreadcrumbsCustom: React.FC<BreadcrumbsCustomProps> = (props) => {
  return (
    <Breadcrumbs
      separator={<Box component="img" src='/images/icons/ic-arrow-right-breadcrumb.svg' alt='icon' />}
      aria-label='breadcrumb'
      sx={{ '& .MuiBreadcrumbs-li': { lineHeight: '14px' }, '& .MuiBreadcrumbs-separator': { mx: '2px' }, mb: '18px' }}
    >
      {props.breadcrumbs.map((breadcrumb, index: number) => (
        breadcrumb.to ? (
          <Link
            underline='hover'
            key={index + 1}
            color='primary.main'
            component={RouterLink}
            to={breadcrumb.to}
            fontSize={'12px'}
            fontWeight={400}
          >
            {breadcrumb.label}
          </Link>
        ) : (
          <Typography key={index + 1} color='#656D78'
            fontSize={'12px'}
            fontWeight={400}>
            {breadcrumb.label}
          </Typography>
        )
      ))}
    </Breadcrumbs>
  );
};

export default BreadcrumbsCustom;
